module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_stills_pet_500_cepita_fresh_pom.c36bf1d6.png";